import { Capitalize } from 'lib/helpers/utility';

import Badge from 'components/shared/Badge/Badge';

import ActionCellRenderer from './ActionCellRenderer';
import ValueCellRenderer from './ValueCellRenderer';

export const cols = [
  {
    headerName: 'Feature Name',
    field: 'name',
    flex: 2,
    sortable: true,
    filter: true,
    valueFormatter: ({ value }) => (value?.trim() ? value : 'N/A')
  },
  {
    headerName: 'Feature Group',
    field: 'group',
    flex: 1,
    sortable: true,
    filter: true
  },
  {
    headerName: 'Type',
    field: 'type',
    cellRenderer: ({ value }) => {
      const color = value === 'boolean' ? 'primary' : 'warning';
      return (
        <div className="flex h-full items-center">
          <Badge text={Capitalize(value)} color={color} />
        </div>
      );
    }
  },
  {
    headerName: 'Setting',
    field: 'value',
    flex: 1,
    cellRenderer: ValueCellRenderer
  },
  {
    field: 'actions',
    headerName: '',
    cellClass: 'no-border',
    cellRenderer: ActionCellRenderer,
    maxWidth: 100,
    minWidth: 36,
    resizable: false,
    sortable: false,
    pinned: 'right'
  }
];
